<template>
  <div class="oct-tab-bar" role="tablist">
    <div class="oct-tab-scroller">
      <div class="oct-tab-scroller__scroll-area">
        <div class="oct-tab-scroller__scroll-content">
          <button
            v-for="(item, i) in items"
            :key="i"
            class="oct-tab"
            :class="[{
              'oct-tab--active': item.value === $_octTabBar_selected
            }, `oct-tab--${length}`]"
            role="tab"
            :aria-selected="item.value === $_octTabBar_selected"
            :tabindex="i"
            @click="$_octTabBar_selected = item.value"
          >
            <span class="oct-tab__content">
              <span class="oct-tab__text-label">{{ item.text }}</span>
            </span>

            <span
              class="oct-tab-indicator"
              :class="{
                'oct-tab-indicator--active': item.value === $_octTabBar_selected
              }"
            >
              <span class="oct-tab-indicator__content oct-tab-indicator__content--underline"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OctTabBar',
  props: {
    /**
     * Tab items
     * @property {string} items[].text Display text
     * @property {string} items[].value Selected value
     */
    items: {
      type: Array,
      default: () => []
    },
    /** Number of tab items */
    length: {
      type: Number,
      default: 2
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    $_octTabBar_selected: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-tab-scroller__scroll-content {
  display: flex;
  margin: 0 oct-rem(-12);
}

.oct-tab {
  font-size: oct-rem(15);
  line-height: (20/15);
  position: relative;
  display: block;
  flex: 0 0 50%;
  margin-top: (-4em/12);
  padding: 0 oct-rem(12) ((16em-4)/15);
  border: none;
  appearance: none;
  background-color: transparent;
  cursor: pointer;

  &--3 {
    flex: 0 0 33.33%;
  }
}

.oct-tab-indicator {
  position: absolute;
  bottom: 0;
  right: oct-rem(12);
  left: oct-rem(12);
  display: block;
}

.oct-tab-indicator__content--underline {
  display: block;
  height: oct-rem(1);
  background-color: $oct-theme--primary;
  opacity: .3;

  .oct-tab-indicator--active &, .oct-tab:hover & {
    height: oct-rem(2);
    opacity: 1;
  }
}
</style>
